import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

import { ROUTER_UTILS } from '../../../utils/router.utils';

@Component({
  templateUrl: './not-found.page.html',
  styleUrls: ['./not-found.page.scss'],
  imports: [RouterLink, MatButton],
})
export class NotFoundPage {
  path = ROUTER_UTILS.config.base;
}
